<template>
  <q-card
    :style="outcomeStyle"
    class="card q-mx-auto"
    style="max-width: 756px; width: 100%; height: 100vh"
  >
    <q-scroll-area
      :thumb-style="{
        background: '#162c479c',
        opacity: 1,
        width: '8px',
        height: '8px',
        borderRadius: '20px',
      }"
      style="width: 756px; height: 100%"
      class="q-px-md"
    >
      <div class="row justify-between">
        <div>
          <q-tabs v-model="tab" inline-label>
            <q-tab
              :name="tab.name"
              no-caps
              v-for="(tab, i) in tabs"
              :key="i"
              :disable="tab.disable"
            >
              <div class="row items-center text-accent">
                <q-icon :name="tab.icon" size="xs"> </q-icon>
                <span class="tabTitle q-ml-sm"> {{ tab.label }}</span>
              </div>
            </q-tab>
          </q-tabs>
        </div>
        <q-btn
          icon="mdi-close"
          flat
          rounded
          @click="closeDialog(false)"
          class="q-mr-sm"
        >
        </q-btn>
      </div>
      <div class="row">
        <q-tab-panels v-model="tab" class="full-width">
          <q-tab-panel name="customYearTotal">
            <div class="row q-mt-lg">
              <span class="title text-accent">Current Total</span>
            </div>
            <div class="row">
              <span class="totalAndUnit">
                {{ currentTotal.toFixed(2) }} tCo2-e</span
              >
            </div>
            <div class="row" v-if="$route.params.hasOwnProperty('year')">
              <span class="year text-accent"> in {{ selectedYear }} </span>
            </div>
            <q-form ref="form">
              <div class="row">
                <span class="inputLabel">Enter custom total</span>
              </div>
              <div class="row items-center q-mb-sm">
                <div class="q-mr-sm">
                  <q-input
                    class="inputField"
                    v-model="value"
                    filled
                    :rules="[
                      (v) => !!v || 'Field is Required',
                      (val) =>
                        !isNaN(parseFloat(val)) || 'Value must be a number',
                      (val) =>
                        parseFloat(val) > currentTotal ||
                        'Value must be greater than current total',
                    ]"
                    dense
                    hide-bottom-space
                  >
                  </q-input>
                </div>
                <div class="totalAndUnit">tCo2-e</div>
              </div>
            </q-form>
          </q-tab-panel>
        </q-tab-panels>
      </div>
      <div class="row justify-end q-px-md">
        <q-btn no-caps class="saveBtn" @click="submit">
          <span class="text text-white">Save</span>
        </q-btn>
      </div>
    </q-scroll-area>
  </q-card>
</template>

<script>
  import { mapGetters } from "vuex";
  import { getMonths } from "@/functions/getMonths";
  export default {
    computed: {
      ...mapGetters({
        selectedSource: "sources/selectedSource",
      }),
    },
    data: () => ({
      tab: "customYearTotal",
      tabs: [
        {
          name: "customYearTotal",
          label: "Enter your custom emission total",
          icon: "mdi-file-document-box",
          disable: false,
        },
      ],
      value: null,
    }),
    mounted() {
      if (this.$route.params.outcomeId) {
        this.$store.dispatch(
          "sources/loadUnknownSourceByOutcomeID",
          this.$route.params.outcomeId
        );
      }
    },
    props: {
      outcomeStyle: {
        type: Object,
        default: {},
      },
      currentTotal: {
        type: Number,
        default: 0,
      },
      selectedYear: {
        default: null,
      },
    },
    methods: {
      closeDialog(init = false) {
        this.$emit("closeDialog", init);
      },
      getMonths: getMonths,
      async submit() {
        const isValid = await this.$refs.form.validate();
        if (isValid && this.selectedSource) {
          let data = {
            sources_id: this.selectedSource.id,
          };
          const months = this.getMonths();
          let value = this.value / 12;

          months.forEach((e) => {
            data[e] = value;
          });
          let payload = {
            year: this.selectedYear,
            sourcesData: [data],
          };
          this.$store.dispatch("sources/data/save", payload);
          let result = await this.$store.dispatch(
            "customSourcesBusinessTotal/new",
            {
              notes: this.notes,
              totalValue: this.value,
              useCustom: 1,
              sources_id: this.selectedSource.id,
              date: this.selectedYear,
            }
          );
          this.closeDialog(true);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .tabTitle {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
  }

  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 900;
    font-size: 15.9366px;
  }

  .inputField {
    width: 306px;
    height: 40px;
  }

  .totalAndUnit {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 900;
    font-size: 27.0146px;
    color: var(--outcome-primary);
  }

  .inputLabel {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 900;
    font-size: 12px;
  }

  .saveBtn {
    width: 133px;
    height: 34px;
    border-radius: 3px;
    background-color: var(--outcome-primary);

    .text {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 500;
      font-size: 9px;
    }
  }
</style>
